/**
 * @file 报名成功
 * @author 黄步威
 */

import React, { Component } from "react";
import { Footer } from "../../components/basic/index";

import "./index.scss";

class Result extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="result-container">
        <div className="main">
          <div className="bg"></div>
          <div className="info">
            <p>稍后我们的课程顾问老师将与您联系安排试读课程</p>
            <p>体验哈兔好课程，好老师，好效果，请保持电话畅通</p>
            <p>及时查看微信好友信息与邮件信息</p>
            <div
              className="back-btn"
              onClick={() => this.props.history.goBack()}
            >
              返回上一页
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Result;
